import {get, post, put, retire} from "$lib/api";

export const getDocumentsForProject = async (project:any) => {
    return await get('/project/' + project.uuid + '/documents');
}

export const getDocument = async (document:any) => {
    return await get('/document/' + document.uuid);
}
export const deleteDocument = async (document:any) => {
    return await retire('/document/' + document.uuid);
}
export const updateDocumentTag = async (document:any, employeeUuid:String, imageTag:String) => {
    return await put('/employee/' + employeeUuid + '/image/' + document.id, {imageTag});
}

export const postContractField = async (field:any) => {
    return await post('/template-document/field', field);
}
export const deleteContractField = async (field:any) => {
    return await retire('/template-document/field/'+field.id);
}

export const updateContractField = async (field:any) => {
    return await put('/template-document/field',  field);
}